module.exports = __webpack_public_path__ + "media/notification1.eb66f7cf.mp3";